export default {
  common: {
    language: 'Bahasa',
    logoAlt: 'Zhongze Education',
    cancel: 'Batal',
  },
  chatService: {
    chatNow: {
      label: 'Sembang sekarang',
    },
    emailGate: {
      title: 'E-mel diperlukan',
      desc: 'Sila masukkan e-mel anda untuk meneruskan sembang.',
      successMessage: 'E-mel telah dihantar. Anda boleh teruskan sembang.',
    },
  },
  nav: {
    home: 'Laman Utama',
    products: 'Produk',
    software: 'Perisian',
    eduServices: 'Perkhidmatan Pendidikan',
    support: 'Perkhidmatan & Sokongan',
    cooperation: 'Kerjasama Pendidikan',
    about: 'Tentang Kami',

    // Sub-menus & Mega Menu
    learningPlatform: 'Platform Pembelajaran Zhongze Education',
    cloudPlatform: 'Platform Awan Zhongze Education',
    laserSoftware: 'Perisian khas untuk peralatan laser',
    makerK12: 'Pendidikan Maker - Sekolah Rendah & Menengah',
    archVocational: 'Model seni bina - Pendidikan Vokasional',
    cultHigherVoc: 'Reka Bentuk Budaya & Kreatif - TVET Lanjutan',
    artsUni: 'Seni & Kraftangan - Universiti',
    afterSales: 'Perkhidmatan selepas jualan',
    faq: 'Soalan Lazim',
    download: 'Pusat Muat Turun',
    companyIntro: 'Profil Syarikat',
    news: 'Berita',
    contact: 'Hubungi kami',
    device: 'Peralatan',
    kits: 'Kit',
    softwareService: 'Perkhidmatan perisian',
    accessories: 'Aksesori',
    forMakers: 'For Makers',
    forEducation: 'For Education',
    kitsSystem: 'Sistem kit',
    kitsAccessories: 'Aksesori kit',
    courses: 'Kursus',
  },
  aboutPage: {
    seoTitle: 'Tentang Kami - Zhongze Education',
    banner: {
      title: 'Tentang Kami',
    },
    about: {
      title: 'Tentang Kami',
      body: 'Zhongze Education ditubuhkan pada tahun 2015. Dengan kerjasama rapat bersama Hong Kong Unicom International, kami membangunkan sistem pendidikan maker yang sesuai untuk kanak-kanak tempatan berasaskan kursus STEAM di Eropah dan Amerika. Melalui pembelajaran dan amali yang bersifat sosial, kami membantu kanak-kanak melangkaui batas dan mencipta sesuatu yang mengagumkan. Berteraskan “Pendidikan STEAM + Ruang Maker”, kami memegang misi “melahirkan pencipta masa depan”, memberi tumpuan kepada pendidikan kreativiti teknologi untuk kanak-kanak dan remaja berumur 3 hingga 16 tahun. Kami mengendalikan ruang pendidikan inovasi sains dan teknologi, serta membangunkan sendiri produk dan kursus pendidikan inovasi sains dan teknologi. Dengan memfokuskan modul seperti perisian reka bentuk pembelajaran, ukiran laser dan pengaturcaraan, kami membentuk ekosistem penyelidikan dan pembangunan kandungan pendidikan yang unik serta kitaran tertutup produk. Membolehkan kanak-kanak memperoleh keupayaan teras yang diperlukan untuk masa depan melalui projek sebenar! Visi kami ialah menjadi penyokong pendidikan inovasi sains dan teknologi bertaraf antarabangsa. Apa yang kami sediakan bukan sahaja kursus dan persekitaran maker, tetapi juga cara pembelajaran yang serba baharu. Kami percaya setiap kanak-kanak ialah inovator masa depan—berfikir dan meneroka seperti saintis, beramal seperti jurutera, berkreativiti seperti pereka, dan belajar menghasilkan seperti seorang maker. Biarkan mereka menemukan diri melalui penerokaan dan membina masa depan melalui amali.',
    },
    intro: {
      title: 'Mengapa memilih kami?',
      desc: 'Menjadi penyokong pendidikan inovasi sains dan teknologi bertaraf antarabangsa, menyediakan kursus dan persekitaran maker, serta menawarkan cara pembelajaran yang serba baharu. Kami percaya setiap kanak-kanak ialah inovator masa depan; biarkan mereka menemukan diri melalui penerokaan dan membina masa depan melalui amali.',
      features: {
        projectLearning:
          'Pembelajaran berasaskan projek: Melalui pembelajaran berasaskan projek, kanak-kanak memperoleh keupayaan teras yang diperlukan untuk masa depan melalui projek sebenar.',
        interactiveExperiments:
          'Eksperimen interaktif: Melalui eksperimen interaktif ini, kanak-kanak bukan sahaja dapat menguasai prinsip sains asas, malah membina kemahiran menyelesaikan masalah, kreativiti dan semangat kerjasama berpasukan.',
      },
    },
    images: {
      aboutAlt: 'Tentang Zhongze Education',
      featureIcon1Alt: 'Ikon pembelajaran berasaskan projek',
      featureIcon2Alt: 'Ikon eksperimen interaktif',
      introAlt: 'Mengapa memilih kami',
    },
  },
  newsPage: {
    banner: {
      title: 'Berita',
    },
    tabs: [
      { id: 'all', name: 'Semua' },
      { id: 'company', name: 'Berita syarikat' },
      { id: 'exhibition', name: 'Berita pameran' },
      { id: 'industry', name: 'Perkembangan industri' },
    ],
    items: [
      {
        title:
          'Henghao Laser bersinar di BETT UK 2025: Memperkasa inovasi pendidikan dengan teknologi laser',
      },
      {
        title:
          'Teras inovasi pendidikan K-12: Bagaimana pemotong laser CO₂ memacu pengajaran STEAM',
      },
      {
        title:
          'Pelanggan Henghao Laser membawa Light 530 bersinar di didacta Italia 2025',
      },
      {
        title:
          'Zhongze Education melancarkan penyelesaian pendidikan pintar baharu',
      },
      {
        title:
          'Trend pendidikan masa depan: Integrasi mendalam AI dan pendidikan maker',
      },
    ],
  },
  newsInformationPage: {
    banner: {
      title: 'Berita',
    },
    tabs: [
      { id: 'all', name: 'Semua' },
      { id: 'company', name: 'Berita syarikat' },
      { id: 'exhibition', name: 'Berita pameran' },
      { id: 'industry', name: 'Perkembangan industri' },
    ],
    items: [
      {
        title:
          'Zhongze Technology melancarkan kit robot pendidikan generasi baharu, menerajui trend baharu pendidikan STEM',
      },
      {
        title:
          'Kecerdasan buatan memasuki kampus: Bagaimana pendidikan pengaturcaraan meningkatkan pemikiran logik pelajar',
      },
      {
        title:
          'Pertandingan Robot Remaja Kebangsaan 2023 berakhir dengan jayanya; pasukan yang disokong Zhongze meraih keputusan cemerlang',
      },
      {
        title:
          'Meneroka pendidikan masa depan: Pelan pembinaan bilik darjah pintar dalam era transformasi digital',
      },
      {
        title:
          'Zhongze Technology mencapai kerjasama strategik dengan beberapa universiti untuk menubuhkan makmal bersama kecerdasan buatan',
      },
    ],
  },

  home: {
    banner: {
      item1: {
        title: 'Pendidikan maker',
        desc: 'Menyediakan ruang untuk eksperimen dan penerokaan, menggalakkan perkembangan menyeluruh pelajar',
      },
      item2: {
        title: 'Buka pintu pengetahuan',
        desc: 'Daripada aplikasi peralatan laser hingga pembelajaran kit dan kursus, kami memenuhi pelbagai keperluan pembelajaran secara menyeluruh.',
      },
      item3: {
        title: 'Kit & kursus',
        desc: 'Keperluan penting untuk meningkatkan keberkesanan kursus pendidikan AI ISTEAM|pendidikan inovasi sains dan teknologi',
      },
    },
    resources: {
      title: 'Sumber pengajaran STEM yang kaya',
      tabs: {
        laser: {
          name: 'Pemotong laser',
          title: 'Peralatan laser',
          desc1: 'Mesin pemotongan & ukiran laser desktop pintar',
          desc2:
            'Pemotongan berketepatan tinggi│Operasi pintar & mudah│Pemprosesan cekap│Selamat & mesra alam',
        },
        software: {
          name: 'Perisian',
          title: 'Perisian pendidikan',
          desc1: 'Perisian serba lengkap pelbagai fungsi',
          desc2: 'Platform Awan | Platform Pembelajaran | Light Maker',
        },
        ai: {
          name: 'Bantuan pengajaran pintar AI',
          title: 'Bantuan pengajaran pintar',
          desc1: 'Pemantauan masa nyata & amaran peranti',
          desc2: 'Pembantu pengajar AI | papan pemuka visual',
        },
        kits: {
          name: 'Kit dan kursus',
          title: 'Kit kursus yang lengkap',
          desc1: 'Pembelajaran berasaskan projek (PBL)',
          desc2: 'Bahan pembelajaran | Amali hands-on',
        },
      },
    },
    different: {
      title: 'Apa yang membezakan kami',
      items: {
        solution: {
          title: 'Penyelesaian pendidikan AI',
          desc: 'Meningkatkan keberkesanan pengajaran dan pengalaman pembelajaran',
        },
        course: {
          title: 'Kursus pemikiran kreatif',
          desc: 'Kursus sesuai untuk kanak-kanak dan remaja berumur 3–16 tahun',
        },
        product: {
          title: 'Produk pendidikan inovasi sains dan teknologi',
          desc: 'Cipta dengan laser satu klik',
        },
        space: {
          title: 'Ruang penerokaan maker',
          desc: 'Menggabungkan inovasi dan praktikaliti',
        },
      },
    },
    creative: {
      title: 'Kreativiti memacu, cipta masa depan',
      machineDesc: 'Mesin pemotongan & ukiran laser desktop pintar',
      lightBlue530Desc: 'Mesin pemotongan & ukiran laser biru pintar',
      markM20Desc: 'Mesin penandaan laser berketepatan tinggi',
      light640Desc: 'Mesin pemotongan & ukiran laser meja profesional',
    },
    innovation: {
      title: 'Bagaimana menggalakkan pembelajaran inovatif?',
      desc: 'Zhongze Education komited membangunkan produk pendidikan inovasi sains dan teknologi berkualiti tinggi termasuk pemotong laser dan lain-lain. Produk ini membantu pelajar menjalankan pembelajaran amali dalam sains, teknologi, kejuruteraan, seni dan matematik.',
      items: {
        steam: 'STEAM',
        coding: 'Pengaturcaraan',
        light530: 'Gunakan Light 530',
        robotics: 'Teknologi robotik',
      },
    },
    bottomBanner: {
      title: 'Merealisasikan pendidikan AI',
      subtitle:
        'AI+pendidikan diperkasa secara digital, menggabungkan idea inovasi',
      desc: 'Fokus pada produk laser tersuai dan perkhidmatan teknikal, membantu institusi & perusahaan mengintegrasikan【AI+pendidikan】',
    },
  },
  software: {
    laserSoftware: {
      bannerTitle: 'Perisian khas peralatan laser  Light Maker',
      bannerDesc:
        'Perisian profesional untuk peralatan laser, ringkas dan cekap, memfokus pada pengalaman pemotongan dan ukiran.',
      bannerImageAlt: 'Antara muka Light Maker',
      creationTitle: 'Jadikan penciptaan lebih mudah',
      features: {
        proDesignTool: 'Alat reka bentuk bertaraf profesional',
        highPrecisionParams: 'Tetapan parameter berketepatan tinggi',
        multiDeviceControl: 'Pengurusan & kawalan pelbagai peranti',
        assetLibrary: 'Sistem pengurusan perpustakaan bahan yang berkuasa',
      },
      intro: {
        imageAlt: 'Paparan fungsi',
        items: {
          item1: {
            title: 'Sistem reka bentuk yang berkuasa dan mudah digunakan',
            desc: 'Perisian penciptaan yang berkuasa, serasi dengan reka bentuk berkualiti tinggi dalam format JPG、DXF、AI、DST、PNG、BMP、TIF、SVG.',
          },
          item2: {
            title: 'Profesional',
            desc: 'Fungsi melukis profesional, memenuhi semua keperluan pembuatan. Sama ada reka bentuk yang kompleks atau pemotongan yang ringkas, semuanya boleh dilakukan dengan mudah.',
          },
        },
      },
      downloadTitle: 'Muat turun perisian',
      downloadButton: 'Muat turun & cuba',
      downloadApps: {
        lightMakerApp: 'LightMaker App',
        laserMakerLightSystem: 'LaserMaker Light System',
      },
    },
    learningPlatform: {
      bannerTitle: 'Platform Pembelajaran Zhongze Education',
      bannerDescLine1:
        'Platform Pembelajaran Zhongze Education ialah alat pembelajaran dalam talian yang inovatif, direka untuk menyediakan penyelesaian perisian pendidikan yang komprehensif kepada pelajar dan guru.',
      bannerDescLine2:
        'Sama ada pada peranti mudah alih atau komputer, pengguna boleh mengakses dan menggunakan platform kami dengan mudah.',
      bannerImageAlt: 'Antara muka Platform Pembelajaran Zhongze Education',
      exploreTitle:
        'Terokai kemungkinan tanpa had, cipta masa depan yang gemilang',
      exploreTabs: [
        { name: 'Cipta' },
        { name: 'Panduan pemula' },
        { name: 'Pembelajaran pemodelan' },
        { name: 'Cipta satu klik' },
        { name: 'Jana imej AI' },
      ],
      tabContentAlt: 'Paparan fungsi',
      introTitle: 'Platform pembelajaran inovatif',
      introItems: [
        {
          title: 'Pengalaman pembelajaran baharu yang cekap',
          desc: 'Platform Pembelajaran Zhongze Education mengintegrasikan pembelajaran kursus, reka bentuk grafik dan pemotongan laser dalam satu tempat. Antara muka berasaskan kad adalah ringkas dan intuitif, operasi lancar dan mudah, menghubungkan reka bentuk kreatif dengan penghasilan fizikal secara lancar—cekap dan mudah digunakan.',
        },
        {
          title: 'Pintar dan mudah, mesra pemula',
          desc: 'Dilengkapi perpustakaan grafik yang kaya dan preset parameter pintar, anda boleh mencipta dengan satu klik dan bermula dalam beberapa saat. Tutorial berpandu terperinci pada telefon mengurangkan halangan permulaan; pemantauan status peranti secara masa nyata di awan melindungi keselamatan pengajaran sepanjang proses.',
        },
      ],
      introImageAlt: 'Platform pembelajaran inovatif',
      galleryAlt: 'Paparan platform',
      downloadTitle: 'Muat turun perisian',
      downloadApps: [
        { name: 'Aplikasi Platform Zhongze Education' },
        { name: 'Perisian Reka Bentuk Zhongze (PC)' },
      ],
      downloadButtonText: 'Muat turun & cuba',
    },
    cloudPlatform: {
      bannerTitle: 'Platform Awan Zhongze Education',
      bannerDesc:
        'Alat pengurusan pendidikan sehenti yang menyokong pengagihan dan pengumpulan tugasan, pemantauan peranti, permintaan pembaikan serta konfigurasi parameter, membantu guru, pelajar dan sekolah mengurus dengan cekap.',
      bannerImageAlt: 'Antara muka Platform Awan Zhongze Education',
      exploreTitle: 'Permudahkan pengurusan pengajaran',
      exploreTabs: [
        { name: 'Cipta' },
        { name: 'Panduan pemula' },
        { name: 'Pembelajaran lanjutan' },
      ],
      tabContentAlt: 'Paparan fungsi',
      introTitle: 'Tingkatkan kecekapan pendidikan',
      introItems: [
        {
          title: 'Mudah dikendalikan',
          desc: 'Cipta satu klik: perpustakaan grafik dan konfigurasi parameter terbina dalam, menyokong penciptaan satu klik untuk memudahkan aliran operasi. Pemantauan peranti: pantau status peranti secara masa nyata bagi memastikan aktiviti pengajaran berjalan lancar.',
        },
        {
          title: 'Pengurusan berpusat',
          desc: 'Peranti disambung selari: menyokong sambungan selari peranti lain di bilik darjah maker. Fungsi pengurusan satu klik meningkatkan kecekapan pengurusan.',
        },
        {
          title: 'Pemantauan masa nyata',
          desc: 'Status peranti: ketahui status operasi peranti secara masa nyata dan hantar permintaan pembaikan apabila berlaku masalah. Penyelenggaraan: sistem akan memberi peringatan berkala berdasarkan tempoh operasi dan kekerapan penggunaan, memanjangkan jangka hayat peranti dan meningkatkan kualiti pemotongan.',
        },
      ],
      introImageAlt: 'Platform pembelajaran inovatif',
      galleryTitle: 'Merealisasikan pendidikan AI',
      galleryDesc:
        'AI+pendidikan diperkasa secara digital, menggabungkan idea inovasi',
    },
  },
  eduServices: {
    banner: {
      title: 'AI+Pendidikan',
      desc: 'Penyelesaian pengajaran digital pintar Zhongze membantu negara melahirkan bakat inovatif. Berteraskan pembangunan pendidikan dan keperluan pelajar, kami menyediakan penyelesaian pendidikan AI menyeluruh untuk sekolah K-12.',
      imageAlt: 'Banner Penyelesaian Pendidikan',
    },
    recommended: {
      title: 'Produk Disyorkan',
      products: [
        { name: 'Light 640', alt: 'Light 640' },
        { name: 'Light 530', alt: 'Light 530' },
        { name: 'Mark M20', alt: 'Mark M20' },
        { name: 'Light Blue 530', alt: 'Light Blue 530' },
      ],
    },
    solutionCategories: {
      title: 'Mewujudkan ruang pengajaran serba lengkap',
      tabs: {
        'teaching-assist': 'Bantuan pengajaran pintar',
        'process-optimize': 'Pengoptimuman aliran pengajaran',
        'device-manage': 'Pengurusan peranti',
      },
      tabContents: {
        'teaching-assist': {
          title: 'Bantuan pengajaran pintar',
          features: [
            '·Pemantauan masa nyata & inventori peralatan',
            '·Pembantu pembelajaran pintar AI',
            '·Papan pemuka visual',
          ],
        },
        'process-optimize': {
          title: 'Pengoptimuman aliran pengajaran',
          features: [
            '·Edarkan dan semak tugasan dalam talian',
            '·Kawalan berpusat jarak jauh sumber kursus awan',
          ],
        },
        'device-manage': {
          title: 'Pengurusan peranti',
          features: [
            '·Pemantauan masa nyata peranti pendidikan',
            '·Permintaan pembaikan peranti jarak jauh',
          ],
        },
      },
      categories: [
        {
          title: 'Edarkan dan semak tugasan dalam talian',
          description:
            'Sistem pengurusan tugasan pintar, meningkatkan kecekapan pengajaran',
        },
        {
          title: 'Permintaan pembaikan peranti jarak jauh',
          description:
            'Perkhidmatan penyelenggaraan dan pembaikan peranti jarak jauh yang mudah',
        },
        {
          title: 'Kawalan berpusat jarak jauh, memudahkan aliran pengajaran',
          description:
            'Platform pengurusan jarak jauh yang bersepadu, mengoptimumkan aliran pengajaran',
        },
        {
          title: 'Sumber kursus awan',
          description: 'Sumber kursus awan dan bahan pengajaran yang kaya',
        },
        {
          title: 'Pemantauan masa nyata peranti pendidikan',
          description:
            'Pantau status peranti secara masa nyata bagi memastikan pengajaran berjalan lancar',
        },
        {
          title: 'Pembantu pengajaran pintar AI',
          description: 'Sistem bantuan pengajaran pintar dipacu AI',
        },
      ],
      solutionCards: [
        { title: 'Penyelesaian sains & inovasi digital pintar' },
        {
          title: 'Penyelesaian bilik darjah pintar (sekolah rendah & menengah)',
        },
        { title: 'Penyelesaian kemahiran TVET (menengah/tinggi)' },
        { title: 'Penyelesaian bilik darjah AI universiti' },
      ],
    },
    solutions: {
      title: 'Penyelesaian pendidikan sehenti',
      items: [
        {
          title: 'Peranti',
          description:
            'Dalam konteks pendidikan diperkasa AI, pemotong laser Henghao disokong oleh platform awan pintar dan berintegrasi rapat dengan Platform Awan Pengajaran Laser Zhongze. Guru boleh mengurus peranti dari jauh, mengagihkan tugasan dan menjejak kemajuan pelajar. Integrasi ini bukan sahaja meningkatkan kecekapan pengajaran, malah memberikan pengalaman pembelajaran yang lebih diperibadikan kepada pelajar.',
          buttonText: 'Lihat butiran →',
        },
        {
          title: 'Perisian',
          description:
            'Platform pendidikan Zhongze menggabungkan teknologi AI untuk menyediakan pembelajaran diperibadikan, alat pintar, pengalaman interaktif dan sumber awan. Ia menyokong pengurusan kursus dan tugasan, pemantauan serta amaran peranti, dan analisis data. Digandingkan dengan Platform Pembelajaran Zhongze (APP/PC) dan alat Light Maker, ia menyokong pengajaran secara menyeluruh, mengoptimumkan sumber, memacu inovasi pendidikan, serta memberi sokongan kukuh kepada guru, pelajar dan institusi pendidikan.',
          buttonText: 'Lihat butiran →',
        },
        {
          title: 'Kursus',
          description:
            'Kursus pemotongan inovasi Zhongze Education ialah kurikulum yang sistematik dan modular, direka khas untuk remaja bagi merangsang minat dan potensi. Ia merangkumi pengetahuan teknologi, pemikiran inovatif, amali berasaskan projek dan eksperimen sains, membantu anak-anak menjadi bakat inovasi masa depan dan menyumbang kepada pembangunan masyarakat.',
          buttonText: 'Lihat butiran →',
        },
      ],
    },
    managementPlatform: {
      title: 'Platform Pengurusan Pengajaran Pintar Zhongze Education',
      desc: 'Menyediakan laluan pembelajaran diperibadikan, alat pengajaran pintar, pengalaman pembelajaran interaktif dan repositori sumber awan. Menyokong pengurusan kursus, penjejakan kemajuan pelajar, tugasan dalam talian, pemantauan dan amaran masa nyata peranti pengajaran, serta analisis data. Melalui integrasi teknologi AI, ia meningkatkan keberkesanan pengajaran, mengoptimumkan peruntukan sumber pendidikan, dan menyediakan sokongan pendidikan menyeluruh untuk pelajar, guru, sekolah dan institusi pendidikan, bersama-sama memacu pembangunan dan inovasi pendidikan.',
      items: [
        {
          title: 'Penyelesaian sains & inovasi digital pintar',
          alt: 'Penyelesaian sains & inovasi digital pintar',
        },
        {
          title: 'Penyelesaian bilik darjah pintar (sekolah rendah & menengah)',
          alt: 'Penyelesaian bilik darjah pintar (sekolah rendah & menengah)',
        },
        {
          title: 'Penyelesaian kemahiran TVET (menengah/tinggi)',
          alt: 'Penyelesaian kemahiran TVET (menengah/tinggi)',
        },
        {
          title: 'Penyelesaian bilik darjah AI universiti',
          alt: 'Penyelesaian bilik darjah AI universiti',
        },
      ],
      action: {
        text: 'Dapatkan penyelesaian khusus',
        alt: 'Ikon hubungi kami',
      },
    },
  },
  makerK12: {
    banner: {
      title: 'Pendidikan Maker — Sekolah Rendah & Menengah',
    },
    intro: {
      title: 'Pemotong laser di sekolah',
      desc: 'Menggunakan pemotong laser di sekolah adalah selamat, tanpa sentuhan dan digital dari idea hingga produk siap. Mudah merealisasikan idea kreatif anak-anak.',
      imageAlt: 'Pemotong laser dalam pembuatan model seni bina',
    },
    scenesFeatured: {
      title: 'Ubah cara pembelajaran dengan alat pendidikan termaju',
      desc: 'Menyediakan teknologi bertaraf industri kepada pelajar untuk meningkatkan kreativiti, pemikiran kritikal dan kemahiran teknikal.',
    },
    scenes: {
      items: [
        {
          title: 'Sediakan platform penciptaan laser untuk setiap pelajar',
          desc: 'Melaksanakan pendekatan pembelajaran, melatih penglibatan pelajar, dan membolehkan pelajar membina pemikiran kreatif di dalam kelas dengan bantuan alat yang berkuasa.',
        },
        {
          title: 'Kit elektronik & pengaturcaraan',
          desc: 'Libatkan pelajar melalui kit interaktif untuk pengaturcaraan hands-on, robotik dan kecerdasan buatan.',
        },
        {
          title: 'Pendidikan teknikal & vokasional',
          desc: 'Gunakan platform teknologi laser untuk membina laluan kerjaya dan meningkatkan kemahiran bagi menyesuaikan diri dengan pasaran pekerjaan yang sentiasa berubah, sekali gus mewujudkan lebih banyak peluang.',
        },
      ],
    },
    solutions: {
      title: 'Model seni bina digunakan secara meluas dalam pelbagai bidang',
      items: [
        { title: 'Sekolah/Daerah K12' },
        { title: 'Institusi latihan' },
        { title: 'Makmal penyelidikan & kursus profesional' },
        { title: 'Ruang maker' },
        { title: 'Perpustakaan/Muzium seni bina' },
        { title: 'Kursus kreatif' },
      ],
    },
    bannerLeft: {
      title: 'Merealisasikan pendidikan AI',
      subtitle:
        'AI+pendidikan diperkasa secara digital, menggabungkan idea inovasi',
    },
    products: {
      tabs: [
        {
          title: 'Peralatan laser',
          title1: 'Alat penciptaan hebat - pemotong laser',
          description:
            'Light 530 dan 640 menggunakan komponen terbaik, proses pembuatan berkualiti tinggi dan prosedur pemeriksaan yang ketat untuk menghasilkan mesin laser berprestasi tinggi, stabil, serta tepat dalam pemotongan dan ukiran. Ia memenuhi keperluan penciptaan laser dalam pelbagai senario pendidikan inovasi sains dan teknologi.',
        },
        {
          title: 'Perisian',
          title1: 'Pembantu melukis - LightMaker',
          description:
            'Menyediakan reka bentuk teknologi yang selamat, pantas, pintar dan inovatif untuk pelajar. LightMaker serasi dengan pelbagai perisian reka bentuk termasuk AI, PS, CorelDRAW, AutoCAD dan Solidworks, serta menyokong muat naik fail berkualiti tinggi seperti JPG, DXF, AI, DST, PNG, BMP, TIF dan SVG.',
        },
        {
          title: 'Kursus',
          title1: 'Pengajaran pelbagai - kursus pendidikan inovasi',
          description:
            'Kami memahami bahawa setiap anak adalah unik. Oleh itu, reka bentuk kursus kami fleksibel dan pelbagai untuk merangsang minat serta potensi setiap pelajar. Kandungan kursus termasuk tetapi tidak terhad kepada pengetahuan asas teknologi, latihan pemikiran inovatif, amali berasaskan projek dan eksperimen sains.',
        },
      ],
    },
    learning: {
      title:
        'Bagaimana menggunakan pemotong laser Zhongze Education dalam pembelajaran kelas?',
      teacher: {
        title: 'Guru',
        lines: [
          'Membuat alat bantu mengajar dan bahan tambahan kursus',
          'Pemotong laser membantu guru menghasilkan bahan pengajaran dan aksesori kelas dengan lebih cekap, malah membolehkan guru mencipta model pengajaran yang lebih inovatif.',
        ],
      },
      student: {
        title: 'Pelajar',
        lines: [
          'Memupuk kemahiran praktikal',
          'Di dalam kelas, pemotong laser membantu pelajar mempelajari reka bentuk, kejuruteraan dan teknologi merentas disiplin, serta merealisasikan imaginasi mereka menjadi karya sebenar.',
        ],
      },
    },
    carousel: {
      items: [
        { alt: 'Adegan pembuatan model seni bina 1' },
        { alt: 'Adegan pembuatan model seni bina 2' },
        { alt: 'Adegan pembuatan model seni bina 3' },
      ],
    },
  },
  archVocational: {
    banner: {
      title: 'Model seni bina - Vokasional',
    },
    intro: {
      title:
        'Bagaimana pemotong laser digunakan untuk membuat model seni bina?',
      desc: 'Anda boleh menggunakan pemotongan dan ukiran laser untuk menghasilkan komponen paling kecil dalam pembuatan model seni bina serta model industri mainan. Ia boleh memotong bahan dengan pantas dan tepat seperti tekstil, plastik, kayu, papan venir, MDF, PMMA, kadbod, kertas, buih, polistirena, filem, akrilik dan lain-lain.',
      imageAlt: 'Pemotong laser dalam pembuatan model seni bina',
    },
    scenesFeatured: {
      title: 'Kuasa inovasi dalam pembuatan model seni bina',
      desc: 'Membantu anda menyiapkan sampel miniatur yang halus dan model seni bina berkualiti tinggi, mempersembahkan pelan kreatif anda dengan lebih kemas.',
    },
    scenes: {
      items: [
        {
          title: 'Ketepatan tinggi',
          desc: 'Pemotong laser boleh memotong bahan dengan ketepatan yang sangat tinggi, dengan ralat dikawal pada julat yang amat kecil, memastikan setiap komponen model seni bina tepat dan sepadan dengan keperluan pelan reka bentuk.',
        },
        {
          title: 'Pelbagai bahan',
          desc: 'Tekstur semula jadi kayu, ketelusan dan kilauan akrilik, serta ringan dan mudah dibentuk pada kertas, semuanya boleh menonjolkan daya tarikan tersendiri melalui pemotongan dan ukiran laser.',
        },
        {
          title: 'Mudah memproses bentuk kompleks',
          desc: 'Untuk bentuk geometri yang kompleks dan perincian halus yang biasa dalam model seni bina, pemotongan laser boleh melakukannya dengan mudah seperti lengkungan dan struktur tidak sekata, sekali gus memberi lebih ruang kreativiti dalam pembuatan model.',
        },
      ],
    },
    solutions: {
      title: 'Model seni bina digunakan secara meluas dalam pelbagai bidang',
      items: [
        { title: 'Pendidikan & penyelidikan akademik' },
        { title: 'Pembuatan model & industri mainan' },
        { title: 'Elemen hiasan & ciri seni bina' },
        { title: 'Hartanah & perancangan bandar' },
        { title: 'Hiasan dalaman & pengubahsuaian' },
      ],
    },
    bannerLeft: {
      title: 'Merealisasikan pendidikan AI',
      subtitle:
        'AI+pendidikan diperkasa secara digital, menggabungkan idea inovasi',
    },
    products: {
      tabs: [
        {
          title: 'Peralatan yang sesuai',
          title1: 'Pilih peralatan yang sesuai',
          description:
            'Peralatan laser boleh menukar idea pelajar kepada hasil sebenar dengan cepat, sama ada pembuatan model, reka bentuk atau penciptaan seni. Dari kerja tangan yang ringkas hingga reka bentuk mekanikal yang kompleks, pemotong dan pengukir laser dapat menyiapkan tugasan dengan tepat, membolehkan pelajar belajar dan berkembang melalui amali.',
        },
        {
          title: 'Reka bentuk sendiri',
          title1: 'Reka bentuk sendiri',
          description:
            'Ubah reka bentuk secara intuitif dan pratonton hasil akhir. Potong dan gandakan perincian mana-mana reka bentuk pada pelbagai bahan: gunakan teks, logo, imej atau foto untuk mengoptimumkan karya anda. Ia juga boleh menghias model seni bina anda dengan cepat.',
        },
        {
          title: 'Pasaran anda',
          title1: 'Tingkatkan kemahiran pelajar',
          description:
            'Mesin penanda laser mudah alih sesuai untuk penandaan dan ukiran perincian pada model seni bina. Ia mudah digunakan dan senang dibawa, menjadikannya alat penting untuk pengajaran seni bina.',
        },
      ],
    },
    learning: {
      title: 'Pengajaran kursus pelbagai disiplin',
      groups: [
        {
          title: 'Model miniatur',
          lines: [
            'Tepat dan terperinci, memenuhi keperluan penciptaan miniatur',
            'Paparkan perincian ukiran/pemotongan laser dengan kemas pada pelbagai bahan, mengurangkan proses yang rumit, mempercepat penciptaan dan mengurangkan ralat kerja tangan.',
          ],
        },
        {
          title: 'Reka bentuk dalaman',
          lines: [
            'Perincian reka bentuk siap sekali gus; kamera terbina dalam memudahkan pratonton kedudukan dan saiz objek, apa yang dilihat itulah yang diperoleh. Laksanakan pemotongan/ukiran dengan cekap sambil mengurangkan pembaziran bahan.',
          ],
        },
      ],
    },
    carousel: {
      items: [
        { alt: 'Adegan pembuatan model seni bina 1' },
        { alt: 'Adegan pembuatan model seni bina 2' },
        { alt: 'Adegan pembuatan model seni bina 3' },
      ],
    },
  },
  artsUniversity: {
    banner: {
      title: 'Seni & Kraftangan - Universiti',
    },
    intro: {
      title:
        'Bagaimana menggunakan peralatan laser untuk memproses karya seni dan kraftangan',
      desc: 'Peralatan ini menyediakan platform untuk pelajar menukar idea kreatif kepada hasil sebenar, sekali gus merangsang pemikiran inovatif dan kreativiti mereka. Pelajar boleh mereka bentuk pelbagai model dan karya seni yang unik seperti kertas potong laser dan cop.',
      imageAlt: 'Peralatan laser dalam pemprosesan seni & kraftangan',
    },
    scenesFeatured: {
      title: 'Pembangunan kemahiran teknikal',
      desc: 'Melalui pengendalian pemotong/pengukir laser, pelajar dapat mempelajari pengetahuan mendalam tentang sains bahan dan teknologi pemprosesan, serta meningkatkan kemahiran hands-on dan penyelesaian masalah.',
    },
    scenes: {
      items: [
        {
          title: 'Rangsang pemikiran kreatif',
          desc: 'Pemotong/pengukir laser boleh digunakan untuk merealisasikan reka bentuk kreatif pelajar seperti membuat model dan karya seni, sekali gus mengukuhkan kreativiti pelajar.',
        },
        {
          title: 'Integrasi pelbagai disiplin',
          desc: 'Teknologi pemotongan dan ukiran laser melibatkan pelbagai disiplin seperti fizik, kimia, sains bahan dan sains komputer. Dalam pengajaran universiti, ia dapat menggalakkan integrasi silang disiplin dan membangunkan keupayaan menyeluruh pelajar.',
        },
        {
          title: 'Projek pengajaran amali',
          desc: 'Teknologi pemotongan dan ukiran laser boleh digunakan untuk projek pengajaran amali di universiti seperti latihan kejuruteraan, reka bentuk seni dan kreativiti budaya. Contohnya, pelajar boleh menggunakan pemotong/pengukir laser untuk membuat model seni bina, komponen mekanikal dan arca seni, menggabungkan teori dengan amali.',
        },
      ],
    },
    solutions: {
      title: 'Aplikasi dalam pembuatan kraftangan di universiti',
      items: [
        { title: 'Produk runcit tersuai' },
        { title: 'Hadiah diperibadikan' },
        { title: 'Pemasaran perayaan' },
        { title: 'Aksesori barang kemas' },
        { title: 'Pakaian diperibadikan' },
      ],
    },
    bannerLeft: {
      title: 'Merealisasikan pendidikan AI',
      subtitle:
        'AI+pendidikan diperkasa secara digital, menggabungkan idea inovasi',
    },
    products: {
      tabs: [
        {
          title: 'Peralatan yang sesuai',
          title1: 'Pilih peralatan yang sesuai',
          description:
            'Dengan memilih peralatan pemotongan/ukiran laser yang sesuai, universiti boleh menyediakan alat pengajaran amali yang maju untuk pelajar, merangsang kreativiti mereka serta meningkatkan kualiti dan kecekapan pengajaran.',
        },
        {
          title: 'Reka bentuk sendiri',
          title1: 'Reka bentuk sendiri',
          description:
            'Ubah reka bentuk secara intuitif dan pratonton hasil akhir. Ukir dan gandakan perincian mana-mana reka bentuk pada pelbagai bahan: gunakan teks, logo, imej atau foto untuk mengoptimumkan karya anda. Pengukir laser sangat mudah digunakan dan boleh menghias karya anda dengan cepat.',
        },
        {
          title: 'Seni & reka bentuk',
          title1: 'Pengajaran program seni & reka bentuk',
          description:
            'Dalam bidang seperti reka bentuk seni dan reka bentuk industri, pemotong/pengukir laser digunakan secara meluas dalam projek reka bentuk kursus dan projek tahun akhir. Pelajar boleh menukar idea reka bentuk kepada hasil sebenar dengan cepat, serta melatih keupayaan pembangunan prototaip produk.',
        },
      ],
    },
    learning: {
      title: 'Bawa laser ke sekolah',
      groups: [
        {
          title: 'Tepat & cekap, jimat masa dan tenaga',
          lines: [
            'Pemotong laser Zhongze menyokong pratonton kamera, penjajaran tepat tanpa pembaziran bahan; pemula pun mudah bermula.',
            'Operasi lancar dan ringkas; masukkan bahan dan mula reka cipta, apa yang dilihat itulah yang diperoleh.',
            'Penciptaan yang tepat, manfaatkan setiap bahan dengan baik; jimat masa, tenaga dan bahan.',
          ],
        },
        {
          title: 'Prestasi kuasa tinggi, mudah untuk pelbagai bahan',
          lines: [
            'Dilengkapi laser CO₂ berkuasa tinggi, sesuai untuk ukiran dan pemotongan.',
            'Mudah memotong dan mengukir akrilik, kayu, buluh dan pelbagai bahan lain, membina aliran kerja yang mesra untuk penggemar kraftangan, menjadikan penciptaan lebih mudah dan cekap.',
          ],
        },
      ],
    },
    carousel: {
      items: [{ alt: 'Adegan pembuatan seni & kraftangan 1' }],
    },
  },
  cultHigherVoc: {
    banner: {
      title: 'Reka Bentuk Budaya & Kreatif — TVET Lanjutan',
    },
    intro: {
      title: 'Peralatan laser dalam reka bentuk budaya & kreatif',
      desc: 'Program reka bentuk budaya & kreatif di institusi TVET lanjutan biasanya dilengkapi peralatan pemotongan dan ukiran laser yang maju seperti pengukir laser. Peralatan ini dapat memenuhi keperluan pengajaran amali pelajar pada pelbagai peringkat.',
      imageAlt: 'Peralatan laser dalam reka bentuk budaya & kreatif',
    },
    scenesFeatured: {
      title: 'Buka kemungkinan tanpa had untuk kreativiti & kualiti',
      desc: 'Dengan prestasi cemerlang dan keupayaan pemotongan yang tepat, ia menjadi alat penting yang tidak boleh dipisahkan daripada pereka budaya & kreatif.',
    },
    scenes: {
      items: [
        {
          title:
            'Pemotongan berketepatan tinggi, memaparkan perincian reka bentuk dengan sempurna',
          desc: 'Untuk corak yang kompleks dan halus serta bentuk yang unik dalam reka bentuk budaya & kreatif, pemotong laser boleh merealisasikannya dengan tepat, memastikan setiap perincian dipersembahkan dengan tepat pada produk akhir.',
        },
        {
          title: 'Pemprosesan pelbagai bahan',
          desc: 'Peralatan laser boleh memproses pelbagai bahan seperti kayu, akrilik, kulit dan logam, menyediakan pilihan bahan yang kaya untuk reka bentuk produk budaya & kreatif.',
        },
        {
          title: 'Operasi pintar, memudahkan proses merealisasikan idea',
          desc: 'Pelajar hanya perlu memasukkan corak yang direka ke dalam komputer, dan pemotong laser akan mengenal pasti serta melakukan pemotongan dengan tepat secara automatik. Operasi pintar ini bukan sahaja mengurangkan keperluan kemahiran profesional operator, malah meningkatkan kestabilan dan kebolehpercayaan proses pengeluaran.',
        },
      ],
    },
    solutions: {
      title: 'Bawa lebih banyak reka bentuk baik ke dalam kehidupan',
      items: [
        { title: 'Lukisan hiasan bertema budaya' },
        { title: 'Reka bentuk lampu kreatif' },
        { title: 'Hiasan & aksesori rumah' },
        { title: 'Bekas pensel & kotak simpanan alat tulis' },
        { title: 'Aksesori gaya etnik' },
        { title: 'Cenderamata pelancongan' },
      ],
    },
    bannerLeft: {
      title: 'Merealisasikan pendidikan AI',
      subtitle:
        'AI+pendidikan diperkasa secara digital, menggabungkan idea inovasi',
    },
    learning: {
      title:
        'Alat pengeluaran dalam reka bentuk budaya & kreatif (TVET lanjutan)',
      groups: [
        {
          title: 'Pemperibadian tersuai',
          lines: [
            'Pemotong/pengukir laser memudahkan pemperibadian seperti foto, nama atau corak khas, memenuhi keperluan pengguna untuk hadiah yang unik dan bermakna.',
            'Sebagai contoh, corak atau teks yang ditentukan pelanggan boleh diukir pada hiasan kayu, aksesori kulit dan hiasan akrilik, menjadikannya lebih diperibadikan.',
          ],
        },
        {
          title: 'Pembuatan produk derivatif budaya & kreatif',
          lines: [
            'Dari cenderamata muzium hingga produk derivatif filem dan animasi, pemotong/pengukir laser menjadikan reka bentuk yang kompleks lebih mudah divisualkan dan dikomersialkan.',
            'Ia boleh menukar elemen seperti tapak bersejarah, mercu tanda dan IP budaya kepada produk sebenar—contohnya memotong papan kayu biasa menjadi hiasan dengan corak dan bentuk unik, atau mengukir kertas biasa menjadi karya seni yang halus.',
          ],
        },
        {
          title: 'Penciptaan DIY',
          lines: [
            'Peralatan laser membantu penggemar kraftangan mencapai penciptaan DIY pada tahap yang lebih tinggi. Daripada kraftangan kecil hingga hiasan rumah yang unik, semuanya boleh direalisasikan dengan cepat melalui teknologi laser.',
          ],
        },
      ],
    },
    carousel: {
      items: [
        { alt: 'Adegan reka bentuk budaya & kreatif 1' },
        { alt: 'Adegan reka bentuk budaya & kreatif 2' },
        { alt: 'Adegan reka bentuk budaya & kreatif 3' },
      ],
    },
  },
  eduCooperation: {
    banner: {
      title: 'Kerjasama Pendidikan',
    },
    advantages: {
      title: 'Kelebihan kerjasama kami',
      items: [
        {
          title: 'Pasukan R&D berpengalaman',
          desc: 'Zhongze mempunyai pasukan profesional yang terdiri daripada jurutera dan pendidik STEM, sentiasa membangunkan produk inovatif yang memenuhi piawaian pendidikan tinggi dan menarik minat pelajar.',
        },
        {
          title: 'Pemerkasaan digital pintar AI+pendidikan',
          desc: 'Platform pintar Zhongze Education: pembelajaran diperibadikan, alat pintar dan pengalaman interaktif. Menyokong pengurusan kursus, penjejakan kemajuan, penyerahan tugasan, pemantauan peranti dan analisis data. Dengan sumber awan yang kaya, pengajaran menjadi lebih cekap.',
        },
        {
          title: 'Sistem kit dan kurikulum yang kaya',
          desc: 'Kami menyediakan kursus daripada peringkat asas hingga lanjutan seperti pemotongan laser, rumah pintar dan pengangkutan pintar, memenuhi keperluan pelajar pelbagai peringkat umur.',
        },
      ],
    },
    modes: {
      title: 'Model kerjasama',
      carouselAlts: [
        'Adegan kerjasama pendidikan',
        'Kelas kerjasama pendidikan',
        'Amali kerjasama pendidikan',
      ],
      items: [
        {
          title: 'Pengimportan kurikulum',
          desc: 'Rakan kerjasama boleh terus mengguna pakai sistem kurikulum kami untuk meningkatkan kualiti pengajaran dengan pantas.',
        },
        {
          title: 'Kit',
          desc: 'Kit direka khas untuk kanak-kanak berumur 3–16 tahun. Melalui bahan eksperimen yang selamat dan mudah digunakan, ia merangsang minat kanak-kanak terhadap sains, teknologi, kejuruteraan, seni dan matematik (STEAM).',
        },
        {
          title: 'Kerjasama produk',
          desc: 'Rakan kerjasama boleh mendapatkan produk pendidikan kami seperti pemotong laser untuk pengajaran dan amali pelajar.',
        },
        {
          title: 'Pembangunan bersama',
          desc: 'Kami mengalu-alukan rakan kerjasama untuk terlibat dalam pembangunan kursus dan produk, bersama-sama memacu inovasi pendidikan.',
        },
      ],
    },
    bottomBanner: {
      lines: [
        'Merealisasikan pendidikan AI',
        'AI+pendidikan diperkasa secara digital, menggabungkan idea inovasi',
      ],
    },
  },
  support: {
    downloadCenter: {
      bannerTitle: 'Pusat Muat Turun',
      sectionTitle: 'Muat turun perisian',
      downloadButtonText: 'Muat turun klien',
      softwareList: [
        { name: 'Light maker App' },
        { name: 'Good-laser Light maker' },
        { name: 'Aplikasi Platform Pembelajaran Zhongze Education' },
        { name: 'Platform Pembelajaran Zhongze Education' },
      ],
    },
    afterSales: {
      bannerTitle: 'Perkhidmatan Selepas Jualan',
      serviceTitle: 'Perkhidmatan Pintar AR',
      serviceItems: [
        {
          title: 'Diagnostik jarak jauh',
          desc: 'Panduan jarak jauh AR: pasukan sokongan teknikal memeriksa status peranti secara masa nyata, mendiagnosis masalah dengan cepat dan memberikan cadangan penyelesaian yang tepat.',
        },
        {
          title: 'Penyelenggaraan maya',
          desc: 'Demonstrasi operasi AR: memaparkan langkah pembaikan secara maya, jelas dan mudah difahami, membantu anda menguasai kaedah dengan mudah.',
        },
        {
          title: 'Tutorial pintar',
          desc: 'Pembelajaran interaktif AR: lihat panduan operasi terus pada peranti, cekap dan mudah.',
        },
        {
          title: 'Respons pantas',
          desc: 'Sokongan segera AR: respons cepat, kurangkan masa menunggu, penyelesaian masalah lebih cekap.',
        },
      ],
      videosTitle: 'Video operasi',
      playButtonText: 'Mainkan video',
      videos: [
        { title: 'Demo buka bungkusan' },
        { title: 'Cara sambungan komunikasi peranti' },
        { title: 'Tutorial penggunaan Light 530' },
        { title: 'Tutorial pemasangan selepas unboxing' },
        { title: 'Operasi asas perisian' },
        { title: 'Penyelesaian masalah biasa' },
      ],
      manualsTitle: 'Manual operasi',
      viewPdfButtonText: 'Lihat fail PDF',
      manuals: [
        { title: 'Manual operasi Light 530' },
        { title: 'Manual operasi Light 640' },
        { title: 'Manual pengguna Blue 530' },
        { title: 'Panduan penyelenggaraan M20' },
        { title: 'Manual keselamatan pemotongan laser' },
      ],
    },
  },

  product: {
    kits: {
      bannerTitle: 'Tiga siri kit utama',
      bannerDesc:
        'Kit menyokong pembelajaran diperibadikan, sesuai untuk pelajar pelbagai peringkat umur dan keperluan pembelajaran. Pada masa yang sama, ia menyediakan sumber dan alat pengajaran yang kaya untuk guru, membantu mereka mengajar dan membimbing dengan lebih berkesan.',
      sections: {
        educationTitle: 'Kit pendidikan',
        educationDesc: 'Memupuk pemikiran inovatif dan kreativiti',
        creativityTitle: 'Kreativiti memacu, cipta masa depan',
        projectsTitle: 'Projek pendidikan yang pelbagai',
      },
      kitsTabs: [
        {
          name: 'Kit Permulaan Pemotongan Laser',
          title:
            'Kit Permulaan Pemotongan Laser\n(Berserta bahan habis pakai papan kayu)',
          desc: 'Kursus STEAM pemotongan laser direka berdasarkan teori kecerdasan pelbagai, konsep pendidikan STEAM dan teori pembelajaran berasaskan projek. Ia disesuaikan untuk pelajar pelbagai peringkat umur bagi memupuk keupayaan inovasi, pemikiran kritikal, penyelesaian masalah, serta kemahiran komunikasi dan kerjasama berpasukan.',
        },
        {
          name: 'Kotak Sains Ajaib',
          title:
            'Kotak Sains Ajaib\n(Berserta papan kayu + pek kit mikro-litar)',
          desc: 'Kursus ini selaras dengan “Standard Kurikulum Sains Pendidikan Wajib (Edisi 2022)”, memfokus pada empat dimensi: konsep sains, pemikiran sains, amali penerokaan, serta sikap dan tanggungjawab, bagi membangunkan kompetensi teras pelajar. Setiap kelas menyiapkan satu hasil sains, merangkumi kemahiran tradisional, kejuruteraan teknologi dan masyarakat serta konsep teras lain; membimbing pelajar berfikir seperti saintis, meningkatkan keupayaan penerokaan dan membina pemikiran saintifik.',
        },
        {
          name: 'Kit Pengaturcaraan AI',
          title: 'Kit Pengaturcaraan AI',
          desc: 'Terokai teknologi masa depan bermula dengan kit pengaturcaraan AI. Kit ladang pintar, rumah pintar, pengangkutan pintar dan kilang pintar membimbing pelajar memahami teknologi pertanian, mengalami kehidupan moden, meneroka kecekapan pengangkutan, serta memahami pembuatan pintar. Amali hands-on merangsang pemikiran inovatif, memupuk keupayaan menyelesaikan masalah, dan membantu pelajar bersedia menghadapi dunia pintar.',
        },
      ],
      creativityItems: [
        {
          title: 'Tingkatkan kemahiran praktikal',
          desc: 'Kit ini menggabungkan pendidikan STEMA (Sains, Teknologi, Kejuruteraan, Seni, Matematik). Melalui operasi hands-on dan amali berasaskan projek, ia meningkatkan kemahiran praktikal dan keupayaan menyelesaikan masalah pelajar secara menyeluruh.',
        },
        {
          title: 'Memupuk pemikiran inovatif',
          desc: 'Menggalakkan pelajar melakukan reka bentuk dan eksperimen inovatif untuk membangunkan pemikiran inovatif dan kreativiti. Dalam projek berpasukan, ia meningkatkan kemahiran komunikasi dan kolaborasi.',
        },
        {
          title: 'Sokongan pengajaran guru',
          desc: 'Menyediakan sumber pengajaran dan alat bantu untuk guru, membantu pengajaran berasaskan projek dilaksanakan dengan lebih cekap serta memudahkan bimbingan dan penilaian.',
        },
      ],
      projectItems: [
        { title: 'Sains' },
        { title: 'Teknologi' },
        { title: 'Pengaturcaraan' },
        { title: 'Seni' },
      ],
      bottomBannerText:
        'Kursus meningkatkan kemahiran praktikal pelajar melalui operasi hands-on dan amali berasaskan projek untuk menyelesaikan masalah sebenar. Ia memupuk pemikiran inovatif dan kreativiti melalui reka bentuk serta eksperimen inovatif. Projek berpasukan meningkatkan kemahiran komunikasi dan kerjasama. Pelajar juga didedahkan kepada teknologi dan alat terkini untuk membantu mereka menyesuaikan diri dengan keperluan masyarakat masa depan.',
    },
    courses: {
      bannerTitle: 'Sistem Kursus',
      bannerDesc:
        'Kursus STEAM yang sistematik direka untuk pelajar pelbagai peringkat umur, menggabungkan sains, teknologi, kejuruteraan, seni dan matematik bagi memupuk bakat inovasi masa depan.',
      bannerAlt: 'Sistem Kursus',
      bottomBannerAlt: 'Paparan kursus sistem kursus',
      sections: {
        kitsTitle: 'Kit kursus',
        kitsDesc: 'Gabungan sempurna perkakasan dan perisian',
        seriesTitle: 'Siri kursus premium',
      },
      courseTabs: [
        {
          name: 'Umur 3-6',
          title: 'Sistem penerokaan sains - prasekolah (6 kursus)',
          desc: 'Melalui fenomena biasa dalam kehidupan seharian, gunakan alat bantu sains untuk meneroka dengan lebih lanjut, seterusnya memahami corak perkembangan dan prinsip sesuatu perkara.',
        },
        {
          name: 'Umur 6-12',
          title: 'Sistem maker STEAM - remaja (3 kursus)',
          desc: 'Membangunkan kreativiti sendiri, menggunakan peralatan dan melakukan amali hands-on untuk menukar idea kepada hasil karya.',
        },
        {
          name: 'Umur 8-13',
          title: 'Sistem kursus pemotongan laser (3 kursus)',
          desc: 'Menggunakan peralatan untuk memotong pelbagai komponen struktur, memasangnya menjadi struktur tiga dimensi, dan memperindah struktur tersebut. Keupayaan pengaturcaraan: memahami logik dan prinsip keputusan dalam pengaturcaraan.',
        },
        {
          name: 'Umur 6-15',
          title: 'Sistem kursus kecerdasan buatan (4 kursus)',
          desc: 'Gunakan peralatan dan alat untuk mereka bentuk serta menghasilkan rupa karya, dan melalui pengaturcaraan menjadikan karya lebih pintar serta mudah digunakan, serta mampu menyelesaikan masalah dalam kehidupan. Keupayaan pengaturcaraan: memahami logik dan prinsip keputusan dalam pengaturcaraan, serta mempelajari sintaks pengaturcaraan Arduino.',
        },
      ],
      introItems: [
        {
          title: 'Amali yang kuat',
          desc: 'Reka bentuk kursus menekankan amali. Pelajar mengendalikan pemotong laser dan peralatan lain secara hands-on, menukar teori kepada kemahiran praktikal.',
        },
        {
          title: 'Memupuk pemikiran inovatif',
          desc: 'Kursus menggalakkan pelajar mereka bentuk dan menghasilkan karya secara kreatif, membangunkan pemikiran inovatif dan keupayaan menyelesaikan masalah.',
        },
        {
          title: 'Pembelajaran dipacu projek',
          desc: 'Kursus menggunakan pendekatan pembelajaran dipacu projek. Melalui penyelesaian tugasan projek yang konkrit, pelajar belajar dan menguasai pengetahuan melalui amali.',
        },
        {
          title: 'Penerokaan teknologi termaju',
          desc: 'Melalui pembelajaran dipacu projek, pelajar belajar secara amali sambil menyiapkan tugasan projek yang konkrit dan menguasai pengetahuan.',
        },
        {
          title: 'Pengajaran sistematik',
          desc: 'Kursus berkembang secara berperingkat daripada asas ke pertengahan, mengajar teknologi pemotongan laser secara sistematik dan membantu pelajar membina asas pengetahuan yang kukuh.',
        },
        {
          title: 'Seronok dan mencabar',
          desc: 'Reka bentuk kursus menggabungkan elemen keseronokan dan cabaran, merangsang minat belajar dan keinginan meneroka dalam kalangan pelajar.',
        },
      ],
      courseListRow1: [{ name: 'Ladang pintar' }, { name: 'Rumah pintar' }],
      courseListRow2: [
        { name: 'Pengangkutan pintar' },
        { name: 'Kilang pintar' },
      ],
      bottomBannerText:
        'Kursus menampilkan amali, pemikiran inovatif dan integrasi merentas disiplin. Ia menggunakan pembelajaran dipacu projek supaya pelajar menguasai teknologi termaju dalam suasana yang seronok dan mencabar. Digabungkan dengan pengajaran sistematik, pendidikan keselamatan dan pembelajaran diperibadikan, ia memupuk kemahiran hands-on, semangat kerjasama berpasukan dan keupayaan menyelesaikan masalah, menggalakkan pembentangan hasil serta meningkatkan rasa pencapaian pelajar.',
    },
    kitsAccessories: {
      bannerTitle: 'Aksesori kit',
      accessories: [
        { name: 'Jalur lampu RGB' },
        { name: 'Modul jam DS1307' },
        { name: 'Sensor suhu & kelembapan DHT11' },
        { name: 'Sensor pengesanan manusia' },
        { name: 'Modul pencahayaan LED' },
        { name: 'Modul kipas' },
        { name: 'Suis opto slot' },
        { name: 'Modul butang' },
        { name: 'Papan pengawal' },
        { name: 'Papan pengembangan' },
        { name: 'Sensor titisan hujan' },
        { name: 'Motor TT dengan papan penyesuai' },
        { name: 'Modul sensor inframerah' },
        { name: 'Kawalan jauh inframerah' },
        { name: 'Gas' },
        { name: 'Modul paparan tujuh segmen 4 digit' },
        { name: 'Papan kekunci matriks' },
        { name: 'Sensor cahaya' },
        { name: 'Modul lampu isyarat' },
        { name: 'Buzzer' },
      ],
    },
    light530: {
      name: 'Light 530',
      bannerTitle: 'Mesin pemotongan & ukiran laser desktop pintar',
      sections: {
        advantages: 'Kelebihan kami',
        aiTitle: 'Merealisasikan pendidikan AI',
        aiSubtitle:
          'AI+pendidikan diperkasa secara digital, menggabungkan idea inovasi',
        carouselTitle: 'Kemungkinan tanpa had ukiran dengan cahaya',
        specsTitle: 'Spesifikasi produk',
      },
      bannerFeatures: [
        'Penggambaran titik / Jejak grafik / Perlindungan keselamatan',
        'Dibangunkan khas untuk pendidikan STEAM dan maker',
      ],
      softwareSection: {
        title: 'Sistem pemotongan laser yang mudah digunakan dan berkuasa',
        items: [
          'Tetapkan parameter pemprosesan berbeza mengikut bahan, seperti pemotongan, ukiran dalam, ukiran cetek dan imbasan.',
          'Perpustakaan bahan lukisan yang kaya meningkatkan kecekapan reka bentuk pengguna.',
          'Kamera menyokong penggambaran titik dan membantu reka bentuk grafik, menjadikan kreativiti realiti.',
        ],
      },
      advantages: [
        {
          tagTitle: 'Laser berkualiti tinggi dan berketepatan tinggi',
          desc: 'Seperti tiub laser CO₂ import asli dengan panjang gelombang 10640nm, memberikan kuasa laser berterusan 50W. Ketebalan pemotongan maksimum sehingga 15mm (akrilik). Kelajuan kerja sehingga 1000mm/s, ketepatan ulangan kedudukan 0.025mm. Memastikan ketepatan untuk memotong dan mengukir hasil kreatif yang halus dengan cepat dan tepat.',
        },
        {
          tagTitle: 'Sistem penapisan gas buangan tiga lapis bersepadu',
          desc: 'Reka bentuk bersepadu kotak angin dengan penapis, arang aktif dan lapisan UV ozon untuk menapis asap dan habuk. Ia lebih bersih dan mesra alam, di samping menjadikan penempatan produk lebih mudah dan kompak tanpa perlu membeli kotak penapisan berasingan atau mengambil ruang tambahan.',
        },
        {
          tagTitle: 'Perlindungan keselamatan keutamaan tertinggi',
          desc: 'Lulus ujian keselamatan tertinggi makmal SGS, produk laser Kelas I yang diperakui FDA. Reka bentuk lampu penunjuk keselamatan dan status operasi yang unik membolehkan anda memantau keadaan operasi mesin dengan jelas dan intuitif.',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        leftSpecs: [
          { label: 'Jenis laser', value: 'Tiub laser kaca CO₂ tertutup' },
          { label: 'Julat naik turun kepala laser', value: '≤25mm' },
          { label: 'Ketebalan bahan yang boleh diletakkan', value: '≤22mm' },
          { label: 'Kaedah fokus', value: 'Fokus automatik, fokus manual' },
          {
            label: 'Kaedah sambungan',
            value: 'Menyokong sambungan USB, kabel rangkaian, WiFi',
          },
          { label: 'Sistem operasi disokong', value: 'Windows, iOS' },
          {
            label: 'Perisian reka bentuk disokong',
            value: 'Ps, Ai, CorelDRAW, AutoCAD, Solidworks dan lain-lain',
          },
          {
            label: 'Format fail disokong',
            value: 'JPG, DXF, AI, DST, PNG, BMP, TIF, SVG dan lain-lain',
          },
          { label: 'Jangka hayat laser', value: '≤9000 jam' },
          {
            label: 'Perisian',
            value: 'LightMaker (PC & mudah alih), Lightburn (PC)',
          },
          {
            label: 'Kaedah kawalan',
            value:
              'Skrin sentuh LCD 5 inci / aplikasi mudah alih / perisian PC',
          },
          { label: 'Bunyi operasi mesin', value: '≤60db' },
          {
            label: 'Sistem penghantaran',
            value:
              'Motor stepper berkelajuan tinggi + rel linear berketepatan tinggi + tali sawat segerak',
          },
          {
            label: 'Perlindungan keselamatan',
            value:
              'Suis interlock: berhenti apabila penutup dibuka; hentian apabila berlanggar; butang kecemasan; kunci keselamatan; lampu penunjuk status; amaran suhu tinggi tangki air',
          },
          { label: 'Sistem bekalan kuasa', value: '230V/110VAC 50HZ/60HZ' },
          { label: 'Berat mesin', value: '≈70kg' },
        ],
        waterCoolingSpecs: [
          {
            label: 'Kaedah penyejukan',
            value: 'Sistem penyejukan air terbina dalam (air beredar)',
          },
          {
            label: 'Voltan operasi',
            value: 'DC 24V penyejukan udara + gegelung aluminium',
          },
          { label: 'Kapasiti tangki air', value: '3.2L' },
          { label: 'Ketinggian pam maksimum', value: '5M' },
          {
            label: 'Kadar aliran air',
            value:
              '1000L/H atau penyejuk air laser khas CW3000 luaran (pilihan)',
          },
        ],
        airPumpSpecs: [
          { label: 'Aliran udara', value: '50L/min' },
          { label: 'Bunyi', value: '≤48dB' },
          { label: 'Tekanan udara', value: '≥0.05Mpa' },
        ],
        exhaustSpecs: [
          { label: 'Kuasa berpenarafan', value: '62W' },
          { label: 'Isipadu aliran udara', value: '280m³/H' },
          { label: 'Bunyi', value: '≤50dB' },
          { label: 'Voltan', value: 'AC 220V/110V' },
        ],
        groups: {
          waterCoolingTitle:
            'Spesifikasi sistem penyejukan air (terbina dalam)',
          airPumpTitle: 'Spesifikasi pam udara (terbina dalam)',
          airPumpValueOnly: 'AC 220V/110V 16W',
          exhaustTitle:
            'Spesifikasi sistem sedutan (unit luaran bersepadu) sedutan sisi bawah',
          filterTitle: 'Sistem penapisan',
          filterValue:
            'Kapas penapis arang aktif + kipas senyap + papan arang aktif gred industri',
        },
      },
    },
    lightbule530: {
      name: 'Light Blue 530',
      bannerTitle: 'Mesin pemotongan & ukiran laser cahaya biru pintar',
      sections: {
        advantages: 'Kelebihan kami',
        aiTitle: 'Merealisasikan pendidikan AI',
        aiSubtitle:
          'AI+pendidikan diperkasa secara digital, menggabungkan idea inovasi',
        carouselTitle: 'Kemungkinan tanpa had ukiran dengan cahaya',
        specsTitle: 'Spesifikasi produk',
      },
      bannerFeatures: [
        'Boleh memproses pelbagai bahan',
        'Cipta dengan yakin, mudah berkarya pada bila-bila masa',
      ],
      advantages: [
        {
          tagTitle: 'Reka bentuk & jejak ruang',
          desc: 'Pengukir cahaya biru bergaya, moden dan kompak, sesuai ditempatkan di rumah, sekolah atau studio. Gabungan badan logam dengan penutup akrilik membolehkan anda melihat proses pemprosesan bahan dengan jelas.',
        },
        {
          tagTitle: 'Pemprosesan tertutup, mengelakkan kecederaan',
          desc: 'Pengukir cahaya biru adalah sepenuhnya tertutup. Jika penutup dibuka semasa tugas berjalan, ia akan berhenti secara automatik. Dalam keadaan kecemasan, mesin boleh dimatikan serta-merta dengan satu suis. Sesuai untuk rumah dan sekolah.',
        },
        {
          tagTitle: 'Pemprosesan pelbagai bahan, menyokong ratusan bahan',
          desc: 'Sesuaikan siri produk dengan bentuk atau gaya yang unik. Tambah aksesori untuk mengukir lebih banyak bahan berbentuk khas seperti cawan dan objek bulat, sangat sesuai untuk keperluan perniagaan kecil anda.',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        groups: {
          waterCoolingTitle: 'Sistem penyejukan',
          airPumpTitle: 'Spesifikasi pam udara',
          airPumpValueOnly: '—',
          exhaustTitle: 'Sistem ekzos',
          filterTitle: 'Sistem penapisan',
          filterValue: '—',
        },
        left: [
          {
            key: 'laserType',
            label: 'Jenis laser',
            value: 'Laser cahaya biru',
          },
          { key: 'laserPower', label: 'Kuasa laser', value: '20W / 40W' },
          {
            key: 'maxCutThickness',
            label: 'Ketebalan pemotongan maksimum',
            value: '≤10mm',
          },
          { key: 'focusMode', label: 'Kaedah fokus', value: 'Fokus manual' },
          {
            key: 'connection',
            label: 'Kaedah sambungan',
            value: 'Sambungan USB',
          },
          {
            key: 'os',
            label: 'Sistem operasi disokong',
            value: 'Windows / Android / iOS',
          },
          {
            key: 'softwareOS',
            label: 'Perisian',
            value: 'LightBurn (PC)',
          },
          {
            key: 'laserLifetime',
            label: 'Jangka hayat laser',
            value: '≥10000 jam',
          },
          {
            key: 'maxMaterialThickness',
            label: 'Ketebalan bahan yang boleh diletakkan',
            value: '15mm',
          },
          { key: 'noise', label: 'Bunyi operasi mesin', value: '≤60dB' },
          { key: 'engraveSpeed', label: 'Kelajuan ukiran', value: '600mm/s' },
          {
            key: 'designSoftware',
            label: 'Perisian reka bentuk disokong',
            value: 'Ps, Ai, CorelDRAW, AutoCAD, Solidworks dan lain-lain',
          },
        ],
        water: [],
        air: [],
        exhaust: [],
        right: [
          {
            key: 'maxSpeed',
            label: 'Kelajuan kerja maksimum',
            value: '1000mm/s',
          },
          {
            key: 'power',
            label: 'Sistem bekalan kuasa',
            value: '230V / 110V AC 50Hz / 60Hz',
          },
          {
            key: 'workTable',
            label: 'Saiz platform kerja',
            value: '520 × 315mm',
          },
          { key: 'accuracy', label: 'Ketepatan kedudukan', value: '±0.01mm' },
          {
            key: 'repeatAccuracy',
            label: 'Ketepatan ulangan',
            value: '±0.005mm',
          },
          {
            key: 'powerRequirement',
            label: 'Keperluan kuasa',
            value: 'AC 220V ±10%, 50Hz',
          },
          { key: 'totalPower', label: 'Kuasa keseluruhan', value: '300W' },
          {
            key: 'transmission',
            label: 'Sistem penghantaran',
            value:
              'Motor stepper berkelajuan tinggi + rel linear berketepatan tinggi + tali sawat segerak',
          },
          {
            key: 'safety',
            label: 'Perlindungan keselamatan',
            value:
              'Suis interlock: berhenti apabila penutup dibuka; had paksi; butang kecemasan; kunci keselamatan',
          },
          { key: 'weight', label: 'Berat mesin', value: '≈50kg' },
          {
            key: 'machineSize',
            label: 'Saiz mesin',
            value: '805 × 585 × 320mm',
          },
        ],
      },
    },
    lightm20: {
      name: 'Mark M20',
      bannerTitle: 'Mesin penanda laser berketepatan tinggi',
      sections: {
        advantages: 'Kelebihan kami',
        aiTitle: 'Merealisasikan pendidikan AI',
        aiSubtitle:
          'AI+pendidikan diperkasa secara digital, menggabungkan idea inovasi',
        carouselTitle: 'Penandaan laser, penyesuaian kreatif',
        specsTitle: 'Spesifikasi produk',
      },
      bannerFeatures: [
        'Perlindungan keselamatan, kawalan dua suis, perlindungan laser',
        'Keupayaan ukiran dan pemotongan berketepatan tinggi, berkelajuan tinggi dan stabil',
      ],
      advantages: [
        {
          tagTitle: 'Pelbagai senario aplikasi',
          desc: 'Peralatan ini sesuai untuk pelbagai industri termasuk ukiran barang kemas, objek diperibadikan dan pengenalan komponen. Ia memenuhi keperluan ukiran tersuai untuk pelbagai kegunaan daripada barang kemas dan botol minyak wangi hingga papan tanda industri kecil.',
        },
        {
          tagTitle: 'Aplikasi inovatif dalam pendidikan',
          desc: 'Mark M20 membawa ketepatan gred industri ke dalam pendidikan, menjadi “pembantu serba boleh” untuk pendidikan inovasi sains dan teknologi, serta membangunkan keupayaan pelajar daripada kemahiran penandaan asas hingga pembangunan projek yang kompleks.',
        },
        {
          tagTitle: 'Kompak dan moden',
          desc: 'Mark M20 direka kompak dan moden dengan jejak ruang kecil, bunyi rendah dan tingkap pandang yang besar, memenuhi keperluan ketahanan tinggi. Penampilan bergayanya mematuhi piawaian keselamatan, sesuai untuk institusi pendidikan dan persekitaran runcit awam.',
        },
        {
          tagTitle: 'Siap penandaan dalam beberapa saat',
          desc: 'Walaupun menggunakan fon yang paling kecil, Mark M20 masih boleh menyiapkan penandaan tepat dalam beberapa saat. Kelajuan yang luar biasa ini digabungkan dengan aliran kerja yang dipermudah dan kecekapan perisian aplikasi laser LightMaker, memastikan produktiviti anda meningkat dengan ketara.',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        groups: {},
        left: [
          { key: 'laserType', label: 'Jenis laser', value: 'Laser gentian' },
          { key: 'laserPower', label: 'Kuasa laser', value: '20W / 30W / 50W' },
          {
            key: 'markArea',
            label: 'Kawasan penandaan',
            value:
              'Standard 110×110mm (boleh diperluas dengan menukar lensa medan, seperti 175×175mm dan lain-lain)',
          },
          {
            key: 'maxHeight',
            label: 'Ketinggian kerja maksimum',
            value: '≤130mm',
          },
          { key: 'connection', label: 'Kaedah sambungan', value: 'Ethernet' },
          {
            key: 'os',
            label: 'Sistem operasi disokong',
            value: 'Windows / iOS / Android',
          },
          {
            key: 'power',
            label: 'Sistem bekalan kuasa',
            value: '230V / 110V AC 50Hz / 60Hz',
          },
          {
            key: 'safety',
            label: 'Perlindungan keselamatan',
            value:
              'Suis interlock: berhenti apabila penutup dibuka; had paksi; butang kecemasan; kunci keselamatan',
          },
          { key: 'software', label: 'Perisian disokong', value: 'Mantimark' },
        ],
        water: [],
        air: [],
        exhaust: [],
        right: [
          {
            key: 'transmission',
            label: 'Sistem penghantaran',
            value:
              'Pengangkatan skru elektrik berketepatan tinggi untuk kepala penanda',
          },
          {
            key: 'fileFormat',
            label: 'Fail yang disokong',
            value: 'SVG / DXF / JPG / JPEG / PNG / BMP / TIF',
          },
          { key: 'spotSize', label: 'Diameter titik fokus', value: '≤20μm' },
        ],
      },
    },
    light640: {
      name: 'Light 640',
      bannerTitle: 'Mesin pemotong & pengukir laser meja pintar',
      sections: {
        advantages: 'Kelebihan kami',
        aiTitle: 'Merealisasikan pendidikan AI',
        aiSubtitle:
          'AI+pendidikan diperkasa secara digital, menggabungkan idea inovasi',
        carouselTitle: 'Pemotongan kreatif bermula di sini',
        specsTitle: 'Spesifikasi produk',
      },
      bannerFeatures: [
        'Pantas / Pintu belakang terbuka / Autofokus cekap',
        'Mesin ukiran dan pemotongan laser serba boleh',
      ],
      models: [
        { id: 'light640', name: 'Light 640' },
        { id: 'light960', name: 'Light 960' },
        { id: 'light1390', name: 'Light 1390' },
        { id: 'light1610', name: 'Light 1610' },
      ],
      advantages: [
        {
          tagTitle: 'Kawasan kerja',
          desc: 'Hasil pemotongan dan ukiran yang cemerlang, pelbagai model dan konfigurasi kuasa laser untuk memenuhi keperluan aplikasi yang berbeza\nJenis laser: CO2 DC\nKuasa laser: 60W-130W\nLight640 (600*400mm)\nLight960 (900*600mm)\nLight1390 (1300*900mm)\nLight1610 (1600*1000mm)',
        },
        {
          tagTitle: 'Autofokus cekap + penentududukan titik merah',
          desc: 'Fungsi autofokus membolehkan fokus dan penentududukan yang cepat serta tepat sebelum pemotongan dan ukiran. Dengan pancaran titik merah untuk penentududukan, anda boleh melihat kedudukan kerja secara masa nyata. Ini menjimatkan banyak masa pemotongan dan ukiran, serta menghasilkan kualiti kerja yang lebih baik.',
        },
        {
          tagTitle: 'Reka bentuk pintu belakang terbuka',
          desc: 'Reka bentuk pintu belakang terbuka membolehkan bahan pemotongan dan ukiran dengan panjang tanpa had. Papan dengan panjang 600mm×∞ menjadikan kerja anda lebih mudah dan kurang terhad.',
        },
      ],
      advantagesByModel: {
        light960: [
          {
            tagTitle: 'Hasil pemotongan dan ukiran yang cemerlang',
            desc: 'Mesin pemotong laser dilengkapi platform pemotongan laser berketepatan tinggi. Pemprosesan bahan seperti kayu dan akrilik telah mencapai standard serta kecekapan peringkat perusahaan, membolehkan pengeluaran pukal produk kraf laser dan membantu meningkatkan produktiviti serta nilai jenama dengan ketara.',
          },
          {
            tagTitle: 'Dilengkapi tiub laser berkualiti dan komponen ketepatan',
            desc: 'Rangkaian produk yang pelbagai membolehkan pemilihan jenis laser dan intensiti pemprosesan yang berbeza mengikut keperluan pelanggan. Ia memenuhi pelbagai keperluan pengeluaran dan menyediakan aplikasi yang lebih luas untuk bahan serta proses seperti kayu, kaca dan akrilik.',
          },
          {
            tagTitle: 'Ujian kualiti optik yang ketat, jaminan kualiti',
            desc: 'Ujian barisan pengeluaran yang ketat, kawalan laluan optik yang tepat serta lebih daripada 5 kali ujian pemotongan dan ukiran memastikan penggunaan tiub laser CO2 bertaraf tinggi dengan output yang stabil dan konsisten. Dengan kestabilan kuasa yang cemerlang dan titik laser yang halus, ukiran yang sekata dapat dicapai, malah butiran kompleks juga boleh diukir.',
          },
        ],
        light1390: [
          {
            tagTitle: 'Hasil pemotongan dan ukiran yang cemerlang',
            desc: 'Mesin pemotong laser dilengkapi platform pemotongan laser berketepatan tinggi. Pemprosesan bahan seperti kayu dan akrilik telah mencapai standard serta kecekapan peringkat perusahaan, membolehkan pengeluaran pukal produk kraf laser dan membantu meningkatkan produktiviti serta nilai jenama dengan ketara.',
          },
          {
            tagTitle: 'Dilengkapi tiub laser berkualiti dan komponen ketepatan',
            desc: 'Rangkaian produk yang pelbagai membolehkan pemilihan jenis laser dan intensiti pemprosesan yang berbeza mengikut keperluan pelanggan. Ia memenuhi pelbagai keperluan pengeluaran dan menyediakan aplikasi yang lebih luas untuk bahan serta proses seperti kayu, kaca dan akrilik.',
          },
          {
            tagTitle: 'Ujian kualiti optik yang ketat, jaminan kualiti',
            desc: 'Ujian barisan pengeluaran yang ketat, kawalan laluan optik yang tepat serta lebih daripada 5 kali ujian pemotongan dan ukiran memastikan penggunaan tiub laser CO2 bertaraf tinggi dengan output yang stabil dan konsisten. Dengan kestabilan kuasa yang cemerlang dan titik laser yang halus, ukiran yang sekata dapat dicapai, malah butiran kompleks juga boleh diukir.',
          },
        ],
        light1610: [
          {
            tagTitle: 'Ciri keselamatan menyeluruh & maju',
            desc: '1. Hentian kecemasan\n2. Lampu amaran\n3. Suis kalis air\n4. Wayar pembumian\n5. Penggera pengesan haba terbina dalam diaktifkan secara automatik apabila mesin beroperasi tidak normal\n6. Perlindungan penutup berkunci\n7. Tingkap perlindungan tahan lasak daripada kaca terbaja',
          },
          {
            tagTitle: 'Tahan lama, kualiti unggul',
            desc: '1. Sangat sesuai untuk projek satu unit atau pengeluaran berskala besar.\n2. Pilihan kawasan kerja yang luas, dari 600 x 400MM hingga 1600 x 1000MM.\n3. Kelajuan ukiran yang tiada tandingan.\n4. Direka oleh pakar industri.\n5. Pilihan ideal untuk aplikasi peribadi, pendidikan dan industri.',
          },
          {
            tagTitle: 'Optimumkan pengeluaran melalui pemantauan pintar',
            desc: 'Direka untuk melindungi komponen peralatan anda yang paling mahal (paksi, kepala laser, komponen optik, kanta) daripada habuk dan kotoran, memastikan operasi bertahun-tahun tanpa masalah walaupun digunakan dengan kerap.',
          },
        ],
      },
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      carouselByModel: {
        light640: {
          title: 'Light 640 — Boleh digunakan untuk apa',
          items: [
            {
              title: 'Light 640 - Projek 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 640 - Projek 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 640 - Projek 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 640 - Projek 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 640 - Projek 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 640 - Projek 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 640 - Projek 6',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 640 - Projek 6',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light960: {
          title: 'Light 960 — Boleh digunakan untuk apa',
          items: [
            {
              title: 'Light 960 - Projek 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 960 - Projek 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 960 - Projek 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 960 - Projek 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 960 - Projek 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 960 - Projek 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 960 - Projek 6',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 960 - Projek 6',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light1390: {
          title: 'Light 1390 — Boleh digunakan untuk apa',
          items: [
            {
              title: 'Light 1390 - Projek 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 1390 - Projek 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 1390 - Projek 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 1390 - Projek 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 1390 - Projek 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 1390 - Projek 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 1390 - Projek 6',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 1390 - Projek 6',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light1610: {
          title: 'Light 1610 — Boleh digunakan untuk apa',
          items: [
            {
              title: 'Light 1610 - Projek 1',
              image: require('@/assets/product/1610-1.png'),
            },
            {
              title: 'Light 1610 - Projek 2',
              image: require('@/assets/product/1610-2.png'),
            },
            {
              title: 'Light 1610 - Projek 3',
              image: require('@/assets/product/1610-3.png'),
            },
            {
              title: 'Light 1610 - Projek 4',
              image: require('@/assets/product/1610-4.png'),
            },
            {
              title: 'Light 1610 - Projek 5',
              image: require('@/assets/product/1610-5.png'),
            },
            {
              title: 'Light 1610 - Projek 6',
              image: require('@/assets/product/1610-6.png'),
            },
            {
              title: 'Light 1610 - Projek 6',
              image: require('@/assets/product/1610-7.png'),
            },
            {
              title: 'Light 1610 - Projek 6',
              image: require('@/assets/product/1610-8.png'),
            },
          ],
        },
      },
      specs: {
        groups: {
          waterCoolingTitle: 'Sistem penyejukan',

          exhaustTitle: 'Sistem ekzos',
        },
        left: [
          { key: 'model', label: 'Model peralatan', value: 'Light 640' },
          { key: 'workArea', label: 'Kawasan kerja', value: '600mm × 400mm' },
          {
            key: 'laserType',
            label: 'Jenis laser',
            value: 'Tiub laser kaca CO₂ bertutup (sealed)',
          },
          {
            key: 'laserPower',
            label: 'Kuasa laser',
            value: '60W / 80W / 100W',
          },
          {
            key: 'zAxis',
            label: 'Ketinggian paksi Z',
            value: '135mm (5.3 inci)',
          },
          {
            key: 'tableSize',
            label: 'Saiz meja kerja',
            value: '700 × 530mm（27.6″ × 20.9″）',
          },
          {
            key: 'maxMaterialFrontBack',
            label: 'Saiz maksimum bahan (pintu depan & belakang tertutup)',
            value: '700 × 530 × 170mm（27.6″ × 20.9″ × 6.7″）',
          },
          {
            key: 'maxMaterialOpen',
            label: 'Saiz maksimum bahan (pintu belakang dibuka)',
            value: '700 × ∞ × 20mm（27.6″ × ∞ × 0.8″）',
          },
          {
            key: 'machineSize',
            label: 'Saiz mesin (Lebar × Panjang × Tinggi)',
            value: '1450 × 950 × 1180mm（57.1″ × 37.4″ × 46.5″）',
          },
          {
            key: 'weight',
            label: 'Berat mesin',
            value: '300kg (660 paun)',
          },
          {
            key: 'maxSpeed',
            label: 'Kelajuan kerja maksimum',
            value: '1000mm/s',
          },
          {
            key: 'accuracy',
            label: 'Ketepatan kedudukan',
            value: '0.01mm – 0.05mm',
          },
          {
            key: 'focusMode',
            label: 'Mod fokus',
            value: 'Autofokus / Fokus manual',
          },
          {
            key: 'resume',
            label: 'Sambung ukiran selepas kuasa terputus',
            value: 'Disokong',
          },
          {
            key: 'transmission',
            label: 'Mekanisme penghantaran',
            value:
              'Motor stepper berkelajuan tinggi + motor gelung tertutup berketepatan tinggi',
          },
          {
            key: 'connection',
            label: 'Kaedah komunikasi',
            value: 'LAN / USB / WiFi',
          },
        ],
        right: [
          {
            key: 'software',
            label: 'Perisian',
            value: 'Good-Laser LightMaker (serasi dengan LightBurn)',
          },
          {
            key: 'process',
            label: 'Proses pemprosesan',
            value: 'Garisan vektor, pemotongan, ukiran dalam, ukiran cetek',
          },
          {
            key: 'fileFormats',
            label: 'Format fail disokong',
            value: 'Bitmap: JPG / PNG / BMP; Vektor: LPC / DXF / PLT / SVG',
          },
          {
            key: 'frequency',
            label: 'Frekuensi',
            value: '50 / 60Hz',
          },
          {
            key: 'phase',
            label: 'Fasa',
            value: 'Satu fasa',
          },
          {
            key: 'current',
            label: 'Arus beban penuh',
            value: '6A',
          },
          {
            key: 'voltage',
            label: 'Voltan',
            value: '230V AC',
          },
          {
            key: 'totalPower',
            label: 'Jumlah kuasa',
            value: '≤ 1.5kW',
          },
          {
            key: 'materials',
            label: 'Bahan yang sesuai',
            value:
              'Kayu, akrilik, kulit, kain, plastik, kadbod, getah, kepingan dua warna, marmar, kaca, aluminium anod dan bahan bukan logam lain',
          },
          {
            key: 'safety',
            label: 'Piawaian keselamatan',
            value:
              'Mematuhi piawaian keselamatan CE EU, dilengkapi perlindungan apabila penutup ruang kerja dibuka, sistem perlindungan penyejukan, sistem penggera automatik kawalan suhu, sistem perlindungan kebocoran arus, sistem perlindungan hentian kecemasan, sistem laluan optik, sistem pemerhatian kaca terbaja, lampu penunjuk status kerja dan lain-lain',
          },
        ],
        water: [
          {
            key: 'coolingMode',
            label: 'Kaedah penyejukan',
            value: 'Penyejukan air',
          },
        ],

        exhaust: [
          {
            key: 'exhaustDiameter',
            label: 'Diameter saluran ekzos',
            value: '150mm',
          },
        ],
      },
      modelSpecOverrides: {
        light960: {
          model: 'Light 960',
          workArea: '900mm × 600mm',
          laserType: 'Tiub laser kaca CO₂ bertutup (sealed)',
          laserPower: '80W / 100W / 120W',
          zAxis: '135mm (5.3 inci)',
          tableSize: '1000 × 730mm（39.4″ × 28.7″）',
          maxMaterialFrontBack: '1000 × 730 × 170mm（39.4″ × 28.7″ × 9.0″）',
          maxMaterialOpen: '1000 × ∞ × 20mm（39.4″ × ∞ × 0.8″）',
          machineSize: '1500 × 1200 × 1180mm（59.1″ × 47.5″ × 45.5″）',
          weight: '410kg (902 paun)',
          maxSpeed: '1000mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: 'Autofokus / Fokus manual',
          resume: 'Disokong',
          transmission:
            'Motor stepper berkelajuan tinggi + motor gelung tertutup berketepatan tinggi',
          connection: 'LAN / USB / WiFi',
          software: 'Good-Laser LightMaker (serasi dengan LightBurn)',
          process: 'Garisan vektor, pemotongan, ukiran dalam, ukiran cetek',
          fileFormats: 'Bitmap: JPG / PNG / BMP; Vektor: LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: 'Satu fasa',
          current: '6A',
          voltage: '230V AC',
          totalPower: '≤ 1.5kW',
          materials:
            'Kayu, akrilik, kulit, kain, plastik, kadbod, getah, kepingan dua warna, marmar, kaca, aluminium anod dan bahan bukan logam lain',
          safety:
            'Mematuhi piawaian keselamatan CE EU, dilengkapi perlindungan apabila penutup ruang kerja dibuka, sistem perlindungan penyejukan air, sistem penggera automatik kawalan suhu, sistem perlindungan kebocoran arus, sistem perlindungan hentian kecemasan, sistem laluan optik, sistem pemerhatian kaca terbaja, lampu penunjuk status kerja dan lain-lain',
          coolingMode: 'Penyejukan air',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
        light1390: {
          model: 'Light 1390',
          workArea: '1300mm × 900mm',
          laserType: 'Tiub laser kaca CO₂ bertutup (sealed)',
          laserPower: '100W / 130W / 150W',
          zAxis: '135mm (5.3 inci)',
          tableSize: '1370 × 900mm（53.4″ × 35.5″）',
          maxMaterialFrontBack: '1370x900x135mm(53.4"x35.5"x5.4")',
          maxMaterialOpen: '1370 × ∞ × 30mm（54.0″ × ∞ × 1.2″）',
          machineSize: '1860 × 1450 × 1200mm（73.3″ × 57.1″ × 46.5″）',
          weight: '500kg (1100 paun)',
          maxSpeed: '600mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: 'Autofokus / Fokus manual',
          resume: 'Disokong',
          transmission:
            'Motor stepper berkelajuan tinggi + motor gelung tertutup berketepatan tinggi',
          connection: 'LAN / USB / WiFi',
          software: 'Good-Laser LightMaker (serasi dengan LightBurn)',
          process: 'Garisan vektor, pemotongan, ukiran dalam, ukiran cetek',
          fileFormats: 'Bitmap: JPG / PNG / BMP; Vektor: LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: 'Satu fasa',
          current: '6A',
          voltage: '230V AC',
          totalPower: '≤ 1.5kW',
          materials:
            'Kayu, akrilik, kulit, kain, plastik, kadbod, getah, kepingan dua warna, marmar, kaca, aluminium anod dan bahan bukan logam lain',
          safety:
            'Mematuhi piawaian keselamatan CE EU, dilengkapi perlindungan apabila penutup ruang kerja dibuka, sistem perlindungan penyejukan air, sistem penggera automatik kawalan suhu, sistem perlindungan kebocoran arus, sistem perlindungan hentian kecemasan, sistem laluan optik, sistem pemerhatian kaca terbaja, lampu penunjuk status kerja dan lain-lain',
          coolingMode: 'Penyejukan air',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
        light1610: {
          model: 'Light 1610',
          workArea: '1600mm × 1000mm',
          laserType: 'Tiub laser kaca CO₂ bertutup (sealed)',
          laserPower: '110W / 130W / 150W',
          zAxis: '135mm (5.3 inci)',
          tableSize: '1700 × 1130mm（66.9″ × 44.5″）',
          maxMaterialFrontBack: '1700 × 1130 × 170mm',
          maxMaterialOpen: '1700 × ∞ × 20mm',
          machineSize: '2200 × 1500 × 1180mm',
          weight: '590kg (1298 paun)',
          maxSpeed: '1000mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: 'Autofokus / Fokus manual',
          resume: 'Disokong',
          transmission:
            'Motor stepper berkelajuan tinggi + motor gelung tertutup berketepatan tinggi',
          connection: 'LAN / USB / WiFi',
          software: 'Good-Laser LightMaker (serasi dengan LightBurn)',
          process: 'Garisan vektor, pemotongan, ukiran dalam, ukiran cetek',
          fileFormats: 'Bitmap: JPG / PNG / BMP; Vektor: LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: 'Satu fasa',
          current: '6A',
          voltage: '230V AC',
          totalPower: '≤ 1.5kW',
          materials:
            'Kayu, akrilik, kulit, kain, plastik, kadbod, getah, kepingan dua warna, marmar, kaca, aluminium anod dan bahan bukan logam lain',
          safety:
            'Sepenuhnya mematuhi piawaian keselamatan CE EU, dilengkapi perlindungan penutup dibuka, perlindungan penyejukan air, penggera suhu, perlindungan kebocoran arus, hentian kecemasan serta sistem gelung tertutup laser',
          coolingMode: 'Penyejukan air',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
      },
    },
  },

  footer: {
    subscribe: {
      placeholder: 'Alamat e-mel anda',
      button: 'Langgan',
    },
    social: {
      tiktok: 'TikTok',
      weibo: 'WeChat Channels',
      wechat: 'WeChat',
      redbook: 'Xiaohongshu',
    },
    companyDesc:
      'Fokus pada pendidikan kreativiti teknologi untuk kanak-kanak dan remaja berumur 3–16 tahun, menubuhkan ruang pendidikan inovasi sains & teknologi, serta membangunkan produk dan kursus secara kendiri merangkumi modul seperti perisian reka bentuk pembelajaran, ukiran laser, pengaturcaraan dan lain-lain.',
    navColumns: [
      {
        title: 'Produk',
        items: [
          { label: 'Peralatan', to: '/product/light530' },
          { label: 'Kit', to: '/product/kits' },
          { label: 'Kursus', to: '/product/courses' },
        ],
      },
      {
        title: 'Perisian',
        items: [
          {
            label: 'Platform Awan Zhongze Sains & Pendidikan',
            to: '/software/cloud-platform',
          },
          {
            label: 'Platform Pembelajaran Zhongze Sains & Pendidikan',
            to: '/software/learning-platform',
          },
          { label: 'Light Maker', to: '/software/laser-software' },
        ],
      },
      {
        title: 'Perkhidmatan Pendidikan',
        items: [
          { label: 'Penyelesaian Pendidikan AI', to: '/edu-services' },
          {
            label: 'Maker Sains & Pendidikan – Sekolah Rendah & Menengah',
            to: '/edu-services/maker-k12',
          },
          {
            label: 'Model Seni Bina – Pendidikan Vokasional Menengah',
            to: '/edu-services/architectural-vocational',
          },
          {
            label: 'Reka Bentuk Kreatif Budaya – Pendidikan Vokasional Tinggi',
            to: '/edu-services/cultural-higher-vocational',
          },
          {
            label: 'Seni & Kraf – Universiti',
            to: '/edu-services/arts-university',
          },
          { label: 'Ruang Inovasi Sains & Teknologi', to: '/edu-services' },
        ],
      },
      {
        title: 'Perkhidmatan dan Sokongan',
        items: [
          { label: 'Pusat Muat Turun', to: '/support/download' },
          { label: 'Perkhidmatan Selepas Jualan', to: '/support/after-sales' },
        ],
      },
      {
        title: 'Kerjasama Pendidikan',
        items: [
          { label: 'Kerjasama Pendidikan', to: '/edu-services/cooperation' },
        ],
      },
      {
        title: 'Tentang Kami',
        items: [
          { label: 'Tentang Kami', to: '/about' },
          { label: 'Berita & Maklumat', to: '/about/news' },
        ],
      },
    ],
    contact: {
      phone: 'Talian jualan: 18379276683',
      email: 'E-mel: sam@zz-steam.com',
      address:
        'Alamat: Blok A, Bangunan Huashengda, Bagua 4th Rd, Futian, Shenzhen',
    },
    qrDesc: 'Ketahui lebih lanjut',
  },

  globalContactForm: {
    title: 'Hubungi kami',
    subtitle:
      'Sila isi borang berikut, kami akan menghubungi anda secepat mungkin',
    fields: {
      name: 'Nama',
      email: 'E-mel',
      phone: 'Telefon',
      company: 'Syarikat',
      message: 'Mesej',
    },
    placeholders: {
      name: 'Sila masukkan nama anda',
      email: 'Sila masukkan e-mel anda',
      phone: 'Sila masukkan nombor telefon anda',
      company: 'Sila masukkan nama syarikat anda',
      message: 'Sila masukkan mesej anda',
    },
    submitting: 'Menghantar...',
    submit: 'Hantar',
    visual: {
      title: 'Menantikan kerjasama dengan anda',
      description:
        'Kami menyediakan perkhidmatan dan sokongan profesional. Jika ada sebarang pertanyaan, sila hubungi kami pada bila-bila masa.',
    },
    contact: {
      phone: 'Nombor telefon',
      email: 'Alamat e-mel',
    },
    validation: {
      name: 'Sila masukkan nama',
      email: 'Sila masukkan e-mel',
      emailFormat: 'Sila masukkan format e-mel yang betul',
      phone: 'Sila masukkan nombor telefon',
      phoneFormat: 'Sila masukkan nombor telefon yang sah',
      message: 'Sila masukkan mesej',
    },
    success: 'Berjaya dihantar! Kami akan menghubungi anda secepat mungkin.',
    networkError: 'Penghantaran gagal, sila cuba lagi kemudian.',
  },
};
